import { AfterViewInit, Component, OnDestroy, OnInit } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { Router } from "@angular/router";
import { V3Client, RegisterCustomerCommand, RegisterCustomerV2ResultRegisterCustomerEnum, CustomerClient, WebCompany } from "../../models";
import { Settings } from "../../app.settings.model";
import { SharedService, AuthService, CompanyService } from "../../services";
import { AppSettings } from "../../app.settings";
import { RegConfirmDialogComponent } from "./reg-confirm-dialog/reg-confirm-dialog.component";
import { SessionDataService } from "src/app/services/session-data.service";
import { EmailListDialogComponent } from "./email-list-dialog/email-list-dialog.component";
import { PromptDialogComponent } from "src/app/components/prompt-dialog/prompt-dialog.component";
import { CustomHttpInterceptor } from "src/app/http-interceptor";
import { AlertDialogComponent } from "src/app/components/alert-dialog/alert-dialog.component";
import { ErrorLoggingService } from "src/app/services/error-logging.service";
import { ErrorDialogComponent } from "src/app/components/error-dialog/error-dialog.component";
import { ProcessingDialogComponent } from "src/app/components/processing-dialog/processing-dialog.component";
import { NgForm } from "@angular/forms";
import { FormValidationService } from "src/app/services/form-validation.service";


@Component({
    selector: "app-register",
    templateUrl: "./register.component.html",
    styleUrls: ["./register.component.scss"],
})
export class RegisterComponent implements OnInit
{

    public settings: Settings;
    public webEmail: string;
    public title: string = "Register";
    private readonly currentState = {
        myTitle: "Register",
        isRegister: true,
    };

    public ifRegister: boolean;
    public displayRegisterTip: boolean;

    private dataLogical: string;

    public registrationEmail: string;
    public custId: string;
    public acctNo: number;
    public lastName: string;
    public labelName: string = "Name on Account";
    public company: WebCompany;

    private loginAttempts: number = 0;
    private allowedAttempts: number = 3;
    errorDialog: any;

    constructor(
        public appSettings: AppSettings,
        public router: Router,
        public dialog: MatDialog,
        private customerV3Client: V3Client,
        private sharedService: SharedService,
        private sessionDataService: SessionDataService,
        private companyService: CompanyService,
        private authService: AuthService,
        private httpInterceptor: CustomHttpInterceptor,
        private apiCustomerClient: CustomerClient,
        private errorlog: ErrorLoggingService,
        private formValidationService: FormValidationService
    )
    {
        this.settings = appSettings.settings;

        if (history.state?.data)
        {
            this.currentState = history.state.data;
        }
    }

    public ngOnInit(): void
    {
        this.dataLogical = this.sessionDataService.DataLogical ?? null;

        if (!this.dataLogical)
        {
            this.sharedService.dataLogical.subscribe(dataLogical =>
            {
                this.dataLogical = dataLogical;
                this.sessionDataService.DataLogical = dataLogical;
            });
        }
        this.ifRegister = this.currentState.isRegister;
        this.title = this.currentState.myTitle;

        this.companyService.company.subscribe(c =>
        {
            this.company = c;
            this.webEmail = this.company.WebEmail ? this.company.WebEmail : this.company.CorpEmail;
        });

    }

    public onCompanyNameChange(value: string): void
    {
        this.lastName = value.trim().replace(/\s+/g, ' ');
    }

    //if cust is commercial set label to company name else last name
    public setLabel(): void
    {
        if (this.custId)
        {
            this.apiCustomerClient.isCommercialCustomer(this.custId, this.dataLogical, "").subscribe(c =>
            {
                c == true ? this.labelName = "Company Name" : this.labelName = "Name on Account";
            });
        }
    }

    public confirmDialog(): void
    {
        const dialogRef = this.dialog.open(RegConfirmDialogComponent, {
            panelClass: "form-field-less-than-180",
            maxWidth: "600px",
            maxHeight: "500px",
        });

        const instance = dialogRef.componentInstance;
        instance.isRegister = this.ifRegister;

        dialogRef.afterClosed().subscribe(_ =>
        {
            this.sharedService.redirect();
        });
    }
    
    public checkFormValidity(form: NgForm): void
    {
        form?.form?.markAllAsTouched();

        if (this.formValidationService.checkFormValidity(form, {
            title: 'Missing Required Fields',
            message: 'All fields must be completed to begin your registration.',
            buttonText: 'Close'
        }))
        {
            this.submitRegistration();
        }
    }

    public submitRegistration(email: string = ""): void
    {
        const dialogText: string = "Registration";

        const dialogRefProcessing = this.dialog.open(ProcessingDialogComponent, {
            data: dialogText,
            width: "400px",
            maxWidth: "90%",
            restoreFocus: false,
            disableClose: true,
        });

        let registerCustomerCommand: RegisterCustomerCommand = {
            CorpIdDataLogical: this.dataLogical,
            CustId: this.custId,
            AcctNo: this.acctNo,
            LastName: this.lastName,
            Email: email,
            IsReset: !this.ifRegister
        };
        if (email.length > 1)
        {
            this.registrationEmail = email;
        }
        this.customerV3Client.register(registerCustomerCommand).subscribe(p =>
        {
            if (p)
            {
                if (p.RegisterCustomerEnum === RegisterCustomerV2ResultRegisterCustomerEnum.CheckEmail)
                {
                    try
                    {
                        this.registrationEmail = p.Email;
                    }
                    catch (error)
                    {
                        this.errorlog.logError(`Registration email is stowed globally ${ error }`)
                    }
                }
                switch (p.RegisterCustomerEnum)
                {
                    case RegisterCustomerV2ResultRegisterCustomerEnum.AlreadyRegistered:
                        this.alreadyRegistered();
                        break;
                    case RegisterCustomerV2ResultRegisterCustomerEnum.NoEmailAvailable:
                        this.promptForEmail();
                        break;
                    case RegisterCustomerV2ResultRegisterCustomerEnum.CheckEmail:
                        this.promptForTempPassword();
                        break;
                    case RegisterCustomerV2ResultRegisterCustomerEnum.ChooseEmail:
                        this.promptEmails(p.Emails);
                        break;
                    case RegisterCustomerV2ResultRegisterCustomerEnum.Restricted:
                        this.restrictedAccountStatus();
                        break;
                    default:
                        console.log("broke loop");
                        break;
                }
            }
            else
            {
                this.dialog.open(AlertDialogComponent, {
                    id: "register-error-alert",
                    panelClass: "form-field-less-than-180",
                    maxWidth: "600px",
                    maxHeight: "500px",
                    data: { title: "An error occurred", message: "Response was empty. Please try again.", buttonText: "Done" }
                });
            }
            dialogRefProcessing.close();
        },
            (error) =>
            {
                dialogRefProcessing.close();
                if (error.toLowerCase().includes("customer"))
                {
                    this.displayRegisterTip = true;
                }
                else
                {
                    this.dialog.open(ErrorDialogComponent, {
                        data: " An error occurred: " + (error.length > 1) ? error : "Unknown",
                    });
                }
            });
    }

    public clearRegisterTip(): void
    {
        if (this.custId || this.acctNo || this.lastName)
        {
            this.displayRegisterTip = false;
        }
    }

    private promptForEmail(): void
    {
        this.apiCustomerClient.checkForLockedAccount(this.custId, this.dataLogical).subscribe((response) =>
        {
            if (response?.length > 1)
            {
                this.showAlert(response)
            }
            else
            {
                const dialogRef = this.dialog.open(PromptDialogComponent, {
                    id: "register-email",
                    panelClass: "form-field-less-than-180",
                    maxWidth: "400px",
                    maxHeight: "300px",
                    disableClose: true,
                    data: {
                        title: "Thank you for registering",
                        message: "Your account does not have an email associated with it.\n\nIn order to complete set-up, please enter your email for a verification code.\n",
                        buttonText: "Done",
                        placeholder: "Email",
                        label: "Email",
                        type: "email"
                    }
                });

                dialogRef.afterClosed().subscribe(result =>
                {
                    if (result && typeof result === "string")
                    {
                        this.submitRegistration(result);
                    }
                });
            }
        });
    }

    private maskEmail(email: string): string
    {
        if (email == null || email == undefined) { return; }
        return email.replace(/^(.)(.*)(.@.*)$/,
            (_, a, b, c) => a + b.replace(/./g, '*') + c);
    }

    private promptEmails(emails: string[]): void
    {
        const dialogRef = this.dialog.open(EmailListDialogComponent, {
            id: "register-emails",
            panelClass: "form-field-less-than-180",
            maxWidth: "600px",
            maxHeight: "500px",
            data: { emails: emails }
        });
        dialogRef.afterClosed().subscribe(result =>
        {
            if (result)
            {
                this.submitRegistration(result.email);
            }
            else
            {
                this.sharedService.redirect();
            }
        });
    }

    private promptForTempPassword(): void
    {
        const dialogRef = this.dialog.open(PromptDialogComponent, {
            id: "register-verify-code",
            panelClass: "form-field-less-than-180",
            maxWidth: "600px",
            maxHeight: "500px",
            disableClose: true,
            data: { title: "Verification Code", message: "Check " + this.maskEmail(this.registrationEmail) + " for the verification code", buttonText: "Done", placeholder: "Code", label: "Code", type: "number", showClose: false }
        });
        dialogRef.afterClosed().subscribe(result =>
        {
            if (result)
            {
                this.sharedService.tempPassword = result;
                const userInfo = {
                    IsCustomer: true,
                    UserName: this.custId,
                    CustID: "",
                    DataLogical: this.dataLogical,
                    Password: result
                };
                this.authService.login(userInfo, false)
                    .subscribe(
                        _ =>
                        {
                            this.router.navigate(["home"]);
                        },
                        error =>
                        {
                            if (error)
                            {
                                this.displayRegisterTip = true;
                                this.httpInterceptor.userErrorAlert(error)
                                this.loginAttempts++;
                                if (this.loginAttempts <= this.allowedAttempts)
                                {
                                    this.promptForTempPassword();
                                }
                                else
                                {
                                    this.router.navigate(['/'], { queryParams: { logical: this.dataLogical } });
                                }

                            }
                        }
                    );
            }
        });
    }

    private restrictedAccountStatus(): void
    {
        let email = this.company.WebEmail ? this.company.WebEmail : this.company.CorpEmail;
        this.dialog.open(AlertDialogComponent, {
            id: "restricted-account-alert",
            panelClass: "form-field-less-than-180",
            maxWidth: "600px",
            maxHeight: "500px",
            data: { title: "Warning", message: "Your account status does not allow you to register to use this website. \n Please contact " + this.company.Name + ". \n Email: " + email + " \n Phone: " + this.company.Phone, buttonText: "Close" }
        })
            .afterClosed().subscribe((_) =>
            {
                this.sharedService.redirect();
            });
    }

    private alreadyRegistered(): void
    {
        this.dialog.open(AlertDialogComponent, {
            id: "already-registered-alert",
            panelClass: "form-field-less-than-180",
            maxWidth: "600px",
            maxHeight: "500px",
            data: { title: "Already Registered", message: "Account number is already registered.", buttonText: "Done" }
        })
            .afterClosed().subscribe((_) =>
            {
                this.sharedService.redirect();
            });
    }
    public showError(err: string): void
    {
        const msg = err;
        this.errorDialog.open(ErrorDialogComponent, {
            minWidth: "360px",
            data: err
        });
    }
    public showAlert(msg: string): void
    {
        this.dialog.open(AlertDialogComponent, {
            minWidth: "360px",
            disableClose: true,
            data: {
                title: "Account Locked",
                message: msg,
                buttonText: "Close"
            }
        });
    }
}
